import './AddWaterSensorPopup.scss'
import { useState, useEffect } from 'react';
import { fetchData } from '../../APICalls/GetRequests';
import { postWaterSensor } from '../../APICalls/GetRequests';
import Cookies from 'js-cookie';

const AddWaterSensorPopup = ({ field, onClose }) => {
    const [housingId, setHousingId] = useState('');
    const [fields, setFields] = useState([]);
    const [selectedField, setSelectedField] = useState(null);


    // NEW: success message state
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        fetchData('fieldnames', Cookies.get('session_key'))
            .then(data => {
                setFields(data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!housingId.trim()) {
        alert("Please enter a housing ID.");
        return;
    }

        const body = { serial: housingId };

        postWaterSensor(body, field.id, Cookies.get('session_key'))
            .then(data => {

                // Show success message
                setSuccessMessage('Water sensor successfully added');

                // Optional: reset form
                setHousingId('');
                setSelectedField(null);

            })
            .catch(error => {
                console.log(error);
            });
    };

    return (
        <div className="AddWaterSensorPopup">
            <div className="popup-container">
                <div className="popup">

                    <h2>Add Water Sensor to {field.name}</h2>

                    {/* SUCCESS MESSAGE */}
                    {successMessage && (
                        <div className="success-message">
                            {successMessage}
                        </div>
                    )}

                    {/* HOUSING ID INPUT */}
                    <form onSubmit={handleSubmit}>
                        <div className='ws-housing-label-input'>
                            <label htmlFor="housingId">Housing ID</label>
                            <input
                                type="text"
                                id="housingId"
                                name="housingId"
                                value={housingId}
                                onChange={(e) => setHousingId(e.target.value)}
                            />
                        </div>
                        <div className='option-button-container'>
                            <button type="button" onClick={onClose}>
                                Cancel
                            </button>

                            <button type="submit">Confirm</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default AddWaterSensorPopup;
